import React, { useEffect, useLayoutEffect, useState } from 'react';
import { globalHistory } from '@reach/router';
import { Nav } from '../Nav';
import Hamburger from './Hamburger';
import { HamburgerWrapper, MenuStyles } from './Menu.styled';

// Safe effect helper to prevent SSR useLayoutEffect warnings
const useIsomorphicLayoutEffect =
	typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export default function Menu() {
	const [isNavOpen, setIsNavOpen] = useState(false);

	// Replaced useLayoutEffect with the safe isomorphic version
	useIsomorphicLayoutEffect(() => {
		if (isNavOpen) {
			document.body.style.overflow = 'hidden';
		}

		return () => {
			document.body.style.overflow = '';
		};
	}, [isNavOpen]);

	useEffect(() => {
		return globalHistory.listen(({ action }) => {
			if (action === 'PUSH') {
				setIsNavOpen(false);
			}
		});
	}, [setIsNavOpen]);

	return (
		<MenuStyles>
			<Nav
				isNavOpen={isNavOpen}
				onClose={() => {
					setIsNavOpen(false);
				}}
			/>
			<HamburgerWrapper>
				<Hamburger
					color={'var(--color)'}
					isOpen={isNavOpen}
					menuClicked={() => {
						setIsNavOpen(!isNavOpen);
					}}
					width={27}
					height={18}
				/>
			</HamburgerWrapper>
		</MenuStyles>
	);
}
